export type FranchisePreferenceType = ('integer'|'string'|'boolean');
export type FranchisePreferenceVisibility = ('public'|'private');

export class FranchisePreference {
    id?: number;
    type?: FranchisePreferenceType;
    visibility?: FranchisePreferenceVisibility;
    name?: string;
    value?: boolean|string|number|null;

    static fromJson(fields: any): FranchisePreference {
        let item = Object.assign(new this(), fields);

        item.value = item?.type === 'integer' ? Number(item.value)
            : item?.type === 'boolean' ? String(item.value).trim().toLowerCase() === 'true'
            : item?.type === 'string' ? String(item.value)
            : null;

        return item;
    }
}
